import { injectable } from 'inversify';
import { ServiceSymbol } from '../app/Container';

export const LocalStorageService = ServiceSymbol<StorageService>('LocalStorageService');
export const SessionStorageService = ServiceSymbol<StorageService>('SessionStorageService');

@injectable()
export class StorageService {

    public static createLocal = () => new StorageService(window.localStorage);
    public static createSession = () => new StorageService(window.sessionStorage);

    constructor(private storage: Storage) {
    }

    public get<T = any>(key: string): T {

        const json = this.storage.getItem(key);
        if (json) {
            return JSON.parse(json) as T;
        }

        return null;
    }

    public put<T = any>(key: string, data: T): void {
        this.storage.setItem(key, JSON.stringify(data));
    }

    public update<T = any>(key: string, callback: (data: T) => T): StorageService {
        const prev = this.get(key);
        const next = callback(prev);
        this.put(key, next);
        return prev;
    }

    public delete<T = any>(key: string): T {
        const prev = this.get(key);
        this.storage.removeItem(key);
        return prev;
    }
}
